import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";

export default function SendNotificationModal({
  isOpen,
  onClose,
  driver,
  AdminId,
   sendSingleNotificationApi 
}) {
  const preConfiguredMessages = [
    { title: "Shift Reminder", body: "Your shift starts in 30 minutes. Please be ready." },
    { title: "Update Location", body: "Please update your live location in the app." },
    { title: "Urgent Task", body: "You have been assigned a new urgent task. Check now." },
    { title: "Custom", body: "" },
  ];

  const [selectedMessageIndex, setSelectedMessageIndex] = useState(0);
  const [customTitle, setCustomTitle] = useState("");
  const [customBody, setCustomBody] = useState("");
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
  let finalTitle =
    preConfiguredMessages[selectedMessageIndex].title === "Custom"
      ? customTitle
      : preConfiguredMessages[selectedMessageIndex].title;

  let finalBody =
    preConfiguredMessages[selectedMessageIndex].title === "Custom"
      ? customBody
      : preConfiguredMessages[selectedMessageIndex].body;

  let newErrors = {};
  if (!finalTitle.trim()) newErrors.title = "Title is required";
  if (!finalBody.trim()) newErrors.body = "Body is required";
  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) return;

  const payload = {
    driverId: [driver.driverId],
    title: finalTitle,
    body: finalBody,
    image: "",
    extra: "",
    adminId: AdminId
  };

  const success = await sendSingleNotificationApi(payload, setSending);

  if (success) {
    onClose();
    setCustomTitle("");
    setCustomBody("");
  }
};


  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-sm fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-50">
          <Dialog.Title className="text-lg font-semibold mb-2">
            Send Notification
          </Dialog.Title>

          <div className="text-sm mb-4">
            <p>
              To: <strong>{driver?.fullName}</strong> (ID: {driver?.driverId})
            </p>
          </div>

          {/* Pre-configured message select */}
          <label className="block text-sm font-medium mb-1">Choose Message</label>
          <select
            value={selectedMessageIndex}
            onChange={(e) => setSelectedMessageIndex(Number(e.target.value))}
            className="border rounded px-2 py-1 w-full mb-3 text-sm"
          >
            {preConfiguredMessages.map((msg, index) => (
              <option key={index} value={index}>
                {msg.title}
              </option>
            ))}
          </select>

          {/* Custom fields if "Custom" selected */}
          {preConfiguredMessages[selectedMessageIndex].title === "Custom" && (
            <>
              <div className="mb-3">
                <label className="block text-sm font-medium mb-1">Title</label>
                <input
                  type="text"
                  value={customTitle}
                  onChange={(e) => setCustomTitle(e.target.value)}
                  className={`border rounded px-2 py-1 w-full text-sm ${
                    errors.title ? "border-red-500" : ""
                  }`}
                  placeholder="Enter custom title"
                />
                {errors.title && <p className="text-red-500 text-xs mt-1">{errors.title}</p>}
              </div>

              <div className="mb-3">
                <label className="block text-sm font-medium mb-1">Body</label>
                <textarea
                  value={customBody}
                  onChange={(e) => setCustomBody(e.target.value)}
                  className={`border rounded px-2 py-1 w-full text-sm ${
                    errors.body ? "border-red-500" : ""
                  }`}
                  rows="3"
                  placeholder="Enter custom message body"
                />
                {errors.body && <p className="text-red-500 text-xs mt-1">{errors.body}</p>}
              </div>
            </>
          )}

          <div className="flex justify-end gap-2 mt-4">
            <Dialog.Close asChild>
              <button className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm">
                Cancel
              </button>
            </Dialog.Close>
            <button
              onClick={handleSend}
              disabled={sending}
              className="px-3 py-1 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm disabled:opacity-50 flex items-center gap-1"
            >
              {sending ? "Sending..." : "Send"}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
